import listComponent from '@/util/proto/listComponent'

export default {
  extends: listComponent,
  data() {
    return {
      data: [],
      params: {},
      columns:[
        {
          type: 'index',
          width: 60,
          title: '序号',
          align: 'center'
        },
        {
          title: '流水号',
          key: 'tradeSerialNum',
          minWidth: 190,
        },
        {
          title: '金额',
          key: 'payAmount',
          minWidth: 90,
          render:(h,params)=>{
            //tradeType：0、人工充值，1、分期费用自动扣费，2：网点充值，3：快递员充值,4:提前结束还款扣款
            let { payAmount , tradeType } = params.row
            if( tradeType == 1 ) payAmount = -payAmount
            const className = payAmount > 0 ? 'color-red' : 'color-green'
            return h('span',{class:className} , payAmount)
          }
        },
        {
          title: '类型',
          key: 'tradeTypeText',
          minWidth: 100,
        }, 
/*        {
          title: '来源',
          key: 'tradeObjTypeText',
          minWidth: 80,
        }, 
        {
          title: '支付方式',
          key: 'payTypeText',
          minWidth: 100,
        },*/
        {
          title: '支付时间',
          key: 'tradeDatetimeText',
          minWidth: 160,
        },
        {
          title: '第三方订单号',
          key: 'thirdTrandeSerialNum',
          minWidth: 180,
        }, {
          title: '状态',
          key: 'payStatusText',
          minWidth: 100,
        }
      ],
      loading: false,
    }
  },
  props: ['carNo'],


  created() {
    this.$watch('carNo' , function(nv){
      if(nv){
        this.search()
      }else{
        this.data = []
      }
    },{immediate:true})
  },

  methods: {

    search() {
      let params = { search: this.carNo, pageSize: this.page.pageSize, pageNum: this.page.pageNum }

      this.loading = true
      this.$request.partnerCarInvoices(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data ? resp.data.list : [], { 'tradeType': '$tradeType', 'tradeDatetime': 'datetime', 'tradeObjType': 'paySource', 'payType': 'payType', 'payStatus': 'payStatus' })

          this.page.total = resp.data.total || 0
        }
      })
    }
  },

  render(){
    return <sl-table ref="table" loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} ></sl-table>
  }
}


